export default __webpack_public_path__ + "static/media/hint_icon_attention.6561d11f.svg";